import moment = require('moment');
import { IAnalytics, GoogleAnalytics } from '../../../App/global/functions/analytics';



export function initCampaignsAndToolkits() {
    let blocks = document.querySelectorAll('[data-campaigns-toolkit]');

    [].forEach.call(blocks, (block) => { setup(block) });
}

function setup(container: HTMLElement) {
    let id = container.getAttribute('data-campaigns-toolkit');
    let map = (window as any).resourceMappings.filter(x => x.id === id)[0];
    if (map) map = map.mappings;

    let firstSelect = container.querySelector('[data-first-select]') as HTMLSelectElement;
    let secondSelect = container.querySelector('[data-second-select]') as HTMLSelectElement;

    let download = container.querySelector('[data-download]');
    var titleElement = container.querySelector('[data-block-title]') as HTMLElement;
    let title = titleElement.innerText;

    if (download) {
        download.addEventListener('click', () => { onDownload(); });
    }

    if (!map) return;

    function onDownload() {
        let singleResource = download.getAttribute('data-download');
        let targetFrame = download.getAttribute('target-frame');
        if (singleResource) {
            singleResource = decodeHTML(singleResource);
            trackClick(title, singleResource, "Single Resource")
            window.open(singleResource, targetFrame);
            return;
        }

        let firstValue = firstSelect ? firstSelect.options[firstSelect.selectedIndex].value : null;
        let secondValue = secondSelect ? secondSelect.options[secondSelect.selectedIndex].value : null;

        if (firstValue !== '' && secondValue !== '' && !(firstValue == null && secondValue == null)) {
            let index = (firstValue || '').concat(secondValue || '');
            let resource = map[index];
            if (secondValue) {
                index = (firstValue || '').concat(' - ').concat(secondValue || '');
            }
            if (resource) {
                resource = decodeHTML(resource);
                trackClick(title, resource, index)
                window.open(resource, targetFrame);
            }
        }
    }

    var decodeHTML = function (html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    var trackClick = function (title: string, url: string, format: string) {
        const analytics = new GoogleAnalytics();
        analytics.pushCampaignAndToolkitsInformation(title, format, url);
    }
}